module.exports = __webpack_public_path__ + "static/media/align-left.82938cba.svg";